var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"v-spinner",class:_vm.containerClass},[_c('div',{staticClass:"v-pulse v-pulse1",class:_vm.bgColor}),_c('div',{staticClass:"v-pulse v-pulse2"}),_c('div',{staticClass:"v-pulse v-pulse3"})])
}
var staticRenderFns = []

export { render, staticRenderFns }